module.exports = __webpack_public_path__ + "img/05342379000646.2ab2db3b.png";